export default __webpack_public_path__ + "static/media/add-user-enabled.63380120.svg";